import { useRuntimeConfig } from '#imports'

import type { DataLayerEvent } from '../../../types'
import { pushEventToDataLayer } from '../../index'

export function pushStagingEventToStagingDataLayer(event: DataLayerEvent) {
  if (!import.meta.client) return

  const {
    public: { GTM_EVENTS_MIGRATION_LOGS_ACTIVATED },
  } = useRuntimeConfig()

  if (!GTM_EVENTS_MIGRATION_LOGS_ACTIVATED) return

  window.stagingDataLayer ??= []
  window.stagingDataLayer.push(event)
}

/**
 * Pushes staging events to the real GTM dataLayer.
 * Gated by the `GTM_EVENTS_MIGRATION_DATALAYER_ACTIVATED` public runtime config flag,
 * so the real dataLayer push can be turned on per environment during the rollout.
 * The staging dataLayer push (controlled by `GTM_EVENTS_MIGRATION_LOGS_ACTIVATED`)
 * is handled separately by `pushStagingEventToStagingDataLayer`.
 */
export function pushStagingEventToRealDataLayer(event: DataLayerEvent) {
  if (!import.meta.client) return

  const {
    public: { GTM_EVENTS_MIGRATION_DATALAYER_ACTIVATED },
  } = useRuntimeConfig()

  if (!GTM_EVENTS_MIGRATION_DATALAYER_ACTIVATED) return

  pushEventToDataLayer(event)
}
